import { LocalPatient } from "../../utils/bridges/types/patient";
import { OfflineAppointment } from "../../firestore/types";
import { calculateAppointmentBillStatus } from "../receipts/receiptMappingWithAppointment";
import { GENDER_TO_INITIAL_MAP } from "../constants";

export const buildPatientFormData = (patient) => {
  if (!patient?.username) return [];

  return [
    {
      label: "UHID",
      value: patient.username,
      key: "uhid",
      type: "string" as const,
    },
  ];
};

export const buildAbhaData = (patient: LocalPatient) => {
  if (!patient?.abha) return undefined;

  return {
    id: patient.abha,
    records: 0,
    status: "SUCCESS" as const, // ABHA_STATUS.SUCCESS
  };
};

export const enrichAppointmentWithPatientData = (
  appointment: OfflineAppointment,
  patient: LocalPatient | null
) => {
  if (!patient) {
    return {
      ...appointment,
      billStatus: calculateAppointmentBillStatus(appointment),
      patient: null,
      formData: [],
      abha: undefined,
    };
  }

  return {
    ...appointment,
    billStatus: calculateAppointmentBillStatus(appointment),
    patient: {
      ...patient,
      oid: patient?.localId || patient?.id,
      fn: patient.personal?.name?.f,
      ln: patient.personal?.name?.l,
      fln: [patient?.personal?.name?.f, patient?.personal?.name?.l]
        .filter(Boolean)
        .join(" "),
      gen: GENDER_TO_INITIAL_MAP[patient.personal?.gender],
      dob: patient.personal?.age?.dob,
      mobile: patient.personal?.phone?.n,
      amount_pending: patient.payments?.dues ?? 0,
    },
    formData: buildPatientFormData(patient),
    abha: buildAbhaData(patient),
  };
};

export const enrichAppointmentsWithPatientData = (
  appointments: OfflineAppointment[],
  patients: LocalPatient[]
) => {
  return appointments
    .map((appointment) => {
      const patient =
        patients.find(
          (p) =>
            p?.localId === appointment?.patient_oid ||
            p?.id === appointment?.patient_oid
        ) ?? null;

      if (!patient) return null;

      return enrichAppointmentWithPatientData(appointment, patient);
    })
    .filter((a): a is NonNullable<typeof a> => Boolean(a));
};
